module.exports = __webpack_public_path__ + "img/emitter_test.1c8bd606.gif";